import gql from 'graphql-tag';

export const GET_LABEL = gql`
  query Label (
    $id: ID,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String,
    $labelCode: String,
    $tradingName: String
  ) {
  Label(
    id: $id,
    dpid: $dpid,
    isni: $isni,
    ipi: $ipi,
    ipn: $ipn,
    musicbrainzGuid: $musicbrainzGuid,
    cisacSocietyID: $cisacSocietyID,
    fullName: $fullName,
    keyName: $fullName,
    abbreviatedName: $abbreviatedName,
    description: $description,
    postalAddressLine: $postalAddressLine,
    postalCityName: $postalCityName,
    postalDistrictName: $postalDistrictName,
    postCode: $postCode,
    postalTerritoryCode: $postalTerritoryCode,
    phoneNumber: $phoneNumber,
    emailAddress: $emailAddress,
    website: $website,
    labelCode: $labelCode,
    tradingName: $tradingName
  ){
    id,
    dpid,
    isni,
    ipi,
    ipn,
    musicbrainzGuid,
    cisacSocietyID,
    fullName,
    keyName,
    abbreviatedName,
    description,
    postalAddressLine,
    postalCityName,
    postalDistrictName,
    postCode,
    postalTerritoryCode,
    phoneNumber,
    emailAddress,
    website,
    labelCode,
    tradingName,
    releases {
      release {
        id,
        title,
        type,
        isMainRelease,
        releaseDetails {
          id,
          artwork {
            id,
            file {
              uri
            }
          }
        }
      }
    }
    assets {
      __typename
      ...on Project {
        id,
        title
      }
      ...on Share {
        id,
        percent,
        territoryCode,
        work {
          id,
          title
        }
      }
      ...on ReleaseDetail {
        release {
          id,
          title,
          type,
          isMainRelease,
          releaseDetails {
            id,
            artwork {
              id,
              file {
                uri
              }
            }
          }
        }
      }
    }
    contributions {
      id,
      role,
      featured,
      contracted,
      isCredited,
      contributedTo {
        __typename
        ...on Component {
          id,
          title
        }
        ...on Work {
          id,
          title
        }

      }
    }

  }
}
`;


export const CREATE_LABEL = gql`
  mutation createLabel (
    $id: ID,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String,
    $labelCode: String,
    $tradingName: String
  ) {
  CreateLabel(
    id: $id,
    dpid: $dpid,
    isni: $isni,
    ipi: $ipi,
    ipn: $ipn,
    musicbrainzGuid: $musicbrainzGuid,
    cisacSocietyID: $cisacSocietyID,
    fullName: $fullName,
    keyName: $fullName,
    abbreviatedName: $abbreviatedName,
    description: $description,
    postalAddressLine: $postalAddressLine,
    postalCityName: $postalCityName,
    postalDistrictName: $postalDistrictName,
    postCode: $postCode,
    postalTerritoryCode: $postalTerritoryCode,
    phoneNumber: $phoneNumber,
    emailAddress: $emailAddress,
    website: $website,
    labelCode: $labelCode,
    tradingName: $tradingName
  ){
    id,
    dpid,
    isni,
    ipi,
    ipn,
    musicbrainzGuid,
    cisacSocietyID,
    fullName,
    keyName,
    abbreviatedName,
    description,
    postalAddressLine,
    postalCityName,
    postalDistrictName,
    postCode,
    postalTerritoryCode,
    phoneNumber,
    emailAddress,
    website,
    labelCode,
    tradingName
  }
}
`;

export const UPDATE_LABEL = gql`
  mutation updateLabel (
    $id: ID!,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String,
    $labelCode: String,
    $tradingName: String
  ) {
  UpdateLabel(
    id: $id,
    dpid: $dpid,
    isni: $isni,
    ipi: $ipi,
    ipn: $ipn,
    musicbrainzGuid: $musicbrainzGuid,
    cisacSocietyID: $cisacSocietyID,
    fullName: $fullName,
    keyName: $fullName,
    abbreviatedName: $abbreviatedName,
    description: $description,
    postalAddressLine: $postalAddressLine,
    postalCityName: $postalCityName,
    postalDistrictName: $postalDistrictName,
    postCode: $postCode,
    postalTerritoryCode: $postalTerritoryCode,
    phoneNumber: $phoneNumber,
    emailAddress: $emailAddress,
    website: $website,
    labelCode: $labelCode,
    tradingName: $tradingName
  ){
    id,
    dpid,
    isni,
    ipi,
    ipn,
    musicbrainzGuid,
    cisacSocietyID,
    fullName,
    keyName,
    abbreviatedName,
    description,
    postalAddressLine,
    postalCityName,
    postalDistrictName,
    postCode,
    postalTerritoryCode,
    phoneNumber,
    emailAddress,
    website,
    labelCode,
    tradingName
  }
}
`;


export const DELETE_LABEL = gql`
  mutation deleteLabel (
    $id: ID!
  ) {
  DeleteLabel(
    id: $id
  ) {
    id
  }
}
`;

// AddLabelTextDepictions(
//   from: _TextInput!
//   to: _LabelInput!
// ): _AddLabelTextDepictionsPayload
// RemoveLabelTextDepictions(
//   from: _TextInput!
//   to: _LabelInput!
// ): _RemoveLabelTextDepictionsPayload
// AddLabelImageDepictions(
//   from: _ImageInput!
//   to: _LabelInput!
// ): _AddLabelImageDepictionsPayload
// RemoveLabelImageDepictions(
//   from: _ImageInput!
//   to: _LabelInput!
// ): _RemoveLabelImageDepictionsPayload
// AddLabelVideoDepictions(
//   from: _VideoInput!
//   to: _LabelInput!
// ): _AddLabelVideoDepictionsPayload
// RemoveLabelVideoDepictions(
//   from: _VideoInput!
//   to: _LabelInput!
// ): _RemoveLabelVideoDepictionsPayload
// AddLabelProjects(
//   from: _LabelInput!
//   to: _ProjectInput!
// ): _AddLabelProjectsPayload
// RemoveLabelProjects(
//   from: _LabelInput!
//   to: _ProjectInput!
// ): _RemoveLabelProjectsPayload
// AddLabelContributions(
//   from: _LabelInput!
//   to: _ContributionInput!
// ): _AddLabelContributionsPayload
// RemoveLabelContributions(
//   from: _LabelInput!
//   to: _ContributionInput!
// ): _RemoveLabelContributionsPayload
// AddLabelWorksPublished(
//   from: _LabelInput!
//   to: _WorkInput!
// ): _AddLabelWorksPublishedPayload
// RemoveLabelWorksPublished(
//   from: _LabelInput!
//   to: _WorkInput!
// ): _RemoveLabelWorksPublishedPayload
// AddLabelReleases(
//   from: _LabelInput!
//   to: _ReleaseDetailInput!
// ): _AddLabelReleasesPayload
// RemoveLabelReleases(
//   from: _LabelInput!
//   to: _ReleaseDetailInput!
// ): _RemoveLabelReleasesPayload
// AddLabelReleasesOwned(
//   from: _LabelInput!
//   to: _ReleaseDetailInput!
// ): _AddLabelReleasesOwnedPayload
// RemoveLabelReleasesOwned(
//   from: _LabelInput!
//   to: _ReleaseDetailInput!
// ): _RemoveLabelReleasesOwnedPayload
// AddLabelRightsShares(
//   from: _LabelInput!
//   to: _ShareInput!
// ): _AddLabelRightsSharesPayload
// RemoveLabelRightsShares(
//   from: _LabelInput!
//   to: _ShareInput!
// ): _RemoveLabelRightsSharesPayload
// AddLabelRightsControlled(
//   from: _LabelInput!
//   to: _ShareInput!
// ): _AddLabelRightsControlledPayload
// RemoveLabelRightsControlled(
//   from: _LabelInput!
//   to: _ShareInput!
// ): _RemoveLabelRightsControlledPayload
// AddLabelRightsAdministered(
//   from: _LabelInput!
//   to: _ShareInput!
// ): _AddLabelRightsAdministeredPayload
// RemoveLabelRightsAdministered(
//   from: _LabelInput!
//   to: _ShareInput!
// ): _RemoveLabelRightsAdministeredPayload
// AddLabelInstrumentsMade(
//   from: _InstrumentInput!
//   to: _LabelInput!
// ): _AddLabelInstrumentsMadePayload
// RemoveLabelInstrumentsMade(
//   from: _InstrumentInput!
//   to: _LabelInput!
// ): _RemoveLabelInstrumentsMadePayload
// AddLabelEquipmentMade(
//   from: _EquipmentInput!
//   to: _LabelInput!
// ): _AddLabelEquipmentMadePayload
// RemoveLabelEquipmentMade(
//   from: _EquipmentInput!
//   to: _LabelInput!
// ): _RemoveLabelEquipmentMadePayload
// AddLabelPaymentsMade(
//   from: _LabelInput!
//   to: _PaymentInput!
// ): _AddLabelPaymentsMadePayload
// RemoveLabelPaymentsMade(
//   from: _LabelInput!
//   to: _PaymentInput!
// ): _RemoveLabelPaymentsMadePayload
// AddLabelPaymentsReceived(
//   from: _PaymentInput!
//   to: _LabelInput!
// ): _AddLabelPaymentsReceivedPayload
// RemoveLabelPaymentsReceived(
//   from: _PaymentInput!
//   to: _LabelInput!
// ): _RemoveLabelPaymentsReceivedPayload
// AddLabelArtists(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _AddLabelArtistsPayload
// RemoveLabelArtists(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _RemoveLabelArtistsPayload
// AddLabelFeaturedArtists(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _AddLabelFeaturedArtistsPayload
// RemoveLabelFeaturedArtists(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _RemoveLabelFeaturedArtistsPayload
